import { values, cloneDeep } from 'lodash';
import moment from 'moment';
import animateScrollTo from 'animated-scroll-to';

// 表单验证提示 应动画滚动至错误区域
// 但需注意 如果页面中[for]不唯一 则不应采取此行为
export function scrollToFieldError(err) {
  const key = Object.keys(err)[0];
  const elem = document.querySelector(`[for="${key}"]`);
  if (elem) animateScrollTo(elem);
}

export function getBrowserProperty() {
  const { userAgent } = window.navigator;
  const isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0,4)); // eslint-disable-line
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && /AppleWebKit/.test(userAgent);
  const isWechat = /MicroMessenger/.test(userAgent);
  const isUc = /UCBrowser/.test(userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  return {
    isMobile,
    isIOS,
    isWechat,
    isUc,
    isSafari
  };
}

export function transformData(data) {
  const result = {};
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const [tempId, attr] = key.split('-');
      if (!result[tempId]) {
        result[tempId] = { tempId };
      }
      result[tempId] = { ...result[tempId], ...{ [attr]: data[key] } };
    }
  }
  return values(result);
}

export function fromatPca(data) {
  const result = cloneDeep(data);
  result.forEach((province) => {
    province.value = province.name;
    province.label = province.name;
    province.children = province.city;
    province.children.forEach((city) => {
      city.value = city.name;
      city.label = city.name;
      city.children = city.districtAndCounty.map((district) => {
        return {
          value: district,
          label: district
        };
      });
    });
  });
  return result;
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4()}${s4()}${s4()}${s4()}${s4()}`;
}

export function scrollToFeedback(props) {
  const elm = document.querySelector('.feedback');
  // const isIE = !!/(Trident|MSIE|Edge)/i.exec(navigator.userAgent);
  if (elm) {
    animateScrollTo(elm);
  } else {
    props.history.push('/#feedback');
  }
}

export function genFields(fields) {
  const result = {};
  fields.forEach((field) => {
    result[field] = {
      value: undefined
    };
  });
  return result;
}
export function createFormFields(fields, dataSource, createFiled) {
  const result = {};
  fields.forEach((field) => {
    result[field] = createFiled({
      ...dataSource[field],
      value: dataSource[field] && dataSource[field].value
    });
  });
  return result;
}

export function getValueFromFields(fileds) {
  const formValue = fileds.map((value) => {
    const result = {};
    for (const attr in value) {
      if (typeof value[attr] === 'object') {
        if (moment.isMoment(value[attr])) {
          result[attr] = moment(value[attr].value).toDate();
        } else {
          result[attr] = value[attr].value !== undefined ? value[attr].value : '';
        }
      } else {
        result[attr] = value[attr];
      }
    }
    result.telcode = value.cellphone && value.cellphone.telcode;
    return result;
  });
  return formValue;
}

export function addPathInCategory({ qid, businessTypeCategory, primaryCategory, categories, validated }) {
  let path;
  if (primaryCategory.value === 'Hardware') {
    path = '/register/basic-ablity';
    const existsDieCasting = categories.some(({ value }) => value === 'Diecasting');
    const existsCNC = categories.some(({ value }) => value === 'CNC' || value === 'Stamping' || value === 'Turning');
    if (existsCNC && existsDieCasting) {
      path = '/register/hard-ware';
    } else if (existsCNC) {
      path = '/register/hard-ware-process';
    } else if (existsDieCasting) {
      path = '/register/hard-ware-dieCasting';
    }
  } else if (primaryCategory.value === 'Plastic') {
    const existsOtherplasticstructuralparts = categories.some(({ value }) => value === 'Otherplasticstructuralparts');
    if (existsOtherplasticstructuralparts) {
      path = '/register/plastic';
    }
  } else if (primaryCategory.value === 'Surface_Treatment') {
    path = '/register/surface';
    const existsAnode = categories.some(({ value }) => value === 'Anode');
    if (existsAnode) {
      path = '/register/surface?secondary=Anode';
    }
  } else if (primaryCategory.value === 'PCBA' || primaryCategory.value === 'System_Assembly') {
    path = '/register/section';
  }
  // if(path) {
  //   path+=`?primaryCategory=${primaryCategory.value}&`
  // }
  return { qid, businessTypeCategory, primaryCategory, categories, path, validated };
}
